import { useGetCustomAppTenantsQuery } from 'gql/graphql';
import { useEffect } from 'react';
import { env, marketplaceSystemIds } from '../config/envConfig';

export const useGetAllMarketplaceAppTenants = () => {
  const { data, fetchMore, loading } = useGetCustomAppTenantsQuery({
    variables: {
      env,
      systemId: marketplaceSystemIds[window.location.hostname],
      state: 'Active',
      first: 100,
    },
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-only',
  });

  useEffect(() => {
    if (!data?.user?.tenants?.pageInfo?.hasNextPage) return;

    const { endCursor } = data?.user?.tenants?.pageInfo || {};

    fetchMore({
      variables: {
        after: endCursor,
      },
      updateQuery: (prev: any, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;

        const pageInfo = fetchMoreResult?.user?.tenants?.pageInfo || {
          hasNextPage: false,
          hasPreviousPage: false,
          startCursor: null,
          endCursor: null,
        };

        return {
          user: {
            ...fetchMoreResult.user,
            tenants: {
              ...fetchMoreResult.user?.tenants,
              edges: [
                ...(prev?.user?.tenants?.edges ?? []),
                ...(fetchMoreResult?.user?.tenants?.edges ?? []),
              ],
              nodes: [
                ...(prev?.user?.tenants?.nodes ?? []),
                ...(fetchMoreResult?.user?.tenants?.nodes ?? []),
              ],
              pageInfo,
              totalCount: fetchMoreResult?.user?.tenants?.totalCount || 0,
            },
          },
        };
      },
    });
  }, [data, fetchMore]);

  return { data, loading };
};
